import { Directive } from '@angular/core';

@Directive({
  selector: '[appInputNextFocus]'
})
export class InputNextFocusDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/directive/input-next-focus.directive.ts